/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hero_EyebrowInputs */

const en_directory_hero_eyebrow = /** @type {(inputs: Directory_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start exploring`)
};

const zh_directory_hero_eyebrow = /** @type {(inputs: Directory_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始探索`)
};

/**
* | output |
* | --- |
* | "Start exploring" |
*
* @param {Directory_Hero_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hero_eyebrow = /** @type {((inputs?: Directory_Hero_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hero_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hero_eyebrow(inputs)
	return zh_directory_hero_eyebrow(inputs)
});
export { directory_hero_eyebrow as "directory.hero.eyebrow" }